import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';

/**
 * Vídeo que carrega via fetch com autenticação (Bearer token).
 * Necessário quando a URL exige Authorization e <video src> não envia headers.
 */
const AuthenticatedVideo = ({
  videoUrl,
  style = {},
  className,
  onClick,
  controls = false,
  autoPlay = false,
  muted = false,
  thumbnail = false,
}) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoUrl) {
      setLoading(false);
      return;
    }

    let revoked = false;
    let createdBlobUrl = null;

    const fetchVideo = async () => {
      try {
        const { data, headers } = await api.get(videoUrl, {
          responseType: 'blob',
        });
        if (revoked) return;
        const type = headers?.['content-type'] || 'video/mp4';
        const url = window.URL.createObjectURL(new Blob([data], { type }));
        createdBlobUrl = url;
        setBlobUrl(url);
      } catch (err) {
        if (!revoked) setError(true);
      } finally {
        if (!revoked) setLoading(false);
      }
    };

    fetchVideo();

    return () => {
      revoked = true;
      if (createdBlobUrl && createdBlobUrl.startsWith('blob:')) {
        window.URL.revokeObjectURL(createdBlobUrl);
      }
    };
  }, [videoUrl]);

  if (loading) {
    return (
      <div
        style={{
          minWidth: thumbnail ? 60 : 200,
          minHeight: thumbnail ? 60 : 120,
          backgroundColor: '#2a3942',
          borderRadius: thumbnail ? 4 : 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style,
        }}
      >
        <span style={{ color: '#8696a0', fontSize: 12 }}>Carregando...</span>
      </div>
    );
  }

  if (error || !blobUrl) {
    return (
      <div
        style={{
          minWidth: thumbnail ? 60 : 200,
          minHeight: thumbnail ? 60 : 120,
          backgroundColor: '#2a3942',
          borderRadius: thumbnail ? 4 : 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style,
        }}
      >
        <span style={{ color: '#8696a0', fontSize: 12 }}>Erro ao carregar vídeo</span>
      </div>
    );
  }

  return (
    <video
      ref={videoRef}
      src={blobUrl}
      style={style}
      className={className}
      onClick={onClick}
      controls={controls}
      autoPlay={autoPlay}
      muted={thumbnail ? true : muted}
      playsInline
      preload={thumbnail ? 'metadata' : 'auto'}
    />
  );
};

export default AuthenticatedVideo;
